export const DEFAULT_ERROR_TEXT = 'Oops! We apologize that something went wrong.'

export const DEFAULT_SUCCESS_TEXT = 'Success!'
